// Components/Admin/AdminProtectedRoute.js
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Cookies from "js-cookie";
const AdminProtectedRoute = () => {

  const token = Cookies.get("admin"); // Check token from cookies
  
  // If token does not exist, redirect to login page
  if (!token) {
    return <Navigate to="/admin/login" />;
  }

  return <Outlet />;
};

export default AdminProtectedRoute;
